import React, { useRef, useState } from "react";

export const JobOfferingContext = React.createContext();

const JobOfferingModalProvider = ({ children }) => {

    const [jobOfferingStep, setJobOfferingStep] = useState(3);
    const [jobs, setJobs] = useState([]);
    const payOutRev = useRef(0);

    return (
        <JobOfferingContext.Provider
            value={{
                jobOfferingStep,
                setJobOfferingStep,
                jobs,
                setJobs,
                payOutRev,
            }}
        >
            {children}
        </JobOfferingContext.Provider>
    )
}

export default JobOfferingModalProvider;